import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import { TableContainer, Paper } from "@mui/material";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewBursaries({ id }) {
  const { logout } = StaffuseAuth();

  const [Bursaries, setBursaries] = useState([]);
  useEffect(() => {
    if (id !== "AddSchool") {
      Get_limited_Choose_Fields_From_MongoDB_With_Search(
        "Registers_2025",
        "All",
        { "BasicInfo.School_id": id, "MetaData.Bursary": "Yes" },
        100,
        setBursaries,
        {},
        logout
      );
    }
  }, [id]);

  return (
    <div>
      <h2>View Bursaries</h2>
      {Bursaries && Array.isArray(Bursaries) && Bursaries.length > 0 ? (
        <>
          <Grid container spacing={2}>
            <Box
              component="main"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                maxWidth: "95%",
                maxHeight: "400px",
                flexGrow: 1,
                p: 1,
                marginLeft: "10px",
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        School_id
                      </TableCell>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        Attendee_id
                      </TableCell>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        Name
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Bursaries.map((Bursarie, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                            "& .MuiTableCell-root": {
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word", // Adjust padding here to make cells smaller
                            },
                          },
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {Bursarie.BasicInfo && Bursarie.BasicInfo.School_id
                            ? Bursarie.BasicInfo.School_id
                            : ""}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {Bursarie._id ? Bursarie._id : ""}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {Bursarie.BasicInfo &&
                          Bursarie.BasicInfo.First_Name &&
                          Bursarie.BasicInfo.Last_Name
                            ? Bursarie.BasicInfo.First_Name +
                              " " +
                              Bursarie.BasicInfo.Last_Name
                            : ""}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          <Link
                            to={`/Staff/ViewAttendee/${Bursarie._id}`}
                            target="_blank"
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <button>View</button>
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </>
      ) : (
        <h3>No Bursaries</h3>
      )}
    </div>
  );
}

export default ViewBursaries;
